import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/Common";
import { JobList } from "@/pages/app/Jobs";
import { useFetch } from "@/lib/api";

export default function AdminJobs() {
  const { data } = useFetch("/jobs");
  const [tab, setTab] = useState("Pending");
  const shown = (data || []).filter((j) => tab === "All" || j.status === tab);
  return (
    <div>
      <PageHeader eyebrow="Moderation" title="Job ads" desc="Approve business job ads and suggest candidates who fit." />
      <Tabs value={tab} onValueChange={setTab} className="mb-6">
        <TabsList>
          {["Pending", "Approved", "Rejected", "Closed", "All"].map((s) => (
            <TabsTrigger key={s} value={s} data-testid={`admin-jobs-tab-${s.toLowerCase()}`}>{s} ({s === "All" ? data?.length ?? 0 : (data || []).filter((j) => j.status === s).length})</TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      {shown.length === 0 && <p className="text-sm text-stone-500">No jobs here.</p>}
      <JobList jobs={shown} base="/admin/jobs" admin />
    </div>
  );
}
